import React from "react";
import { Navigate } from "react-router-dom";

// Keep the existing route pointed at the API-backed category editor.
export default function AddCategoryForm() {
  return <Navigate to="/home/categories?new=1" replace />;
}
